module.exports = __webpack_public_path__ + "img/e06f137db86dc0f6433be97d35fe341b.4b3f81bf.png";